import React, { useState, useEffect } from 'react';

function ProjectAircraftwar() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch('https://picsum.photos/list')
      .then(response => response.json())
      .then(data => {
        const randomImages = [1, 2, 3].map(() => {
          const randomId = data[Math.floor(Math.random() * data.length)].id;
          return `https://picsum.photos/900/500?image=${randomId}`;
        });
        setImages(randomImages);
      })
      .catch(err => console.log(err));
  }, []);

  if (images.length === 0) return null;

  return (
    <div id="carouselAircraft" className="carousel slide" data-ride="carousel" data-interval="5000">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={images[0]} className="d-block w-100" alt="First slide" />
          <div className="carousel-caption">
            <h3>First slide label</h3>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
          </div>
        </div>
        <div className="carousel-item">
          <img src={images[1]} className="d-block w-100" alt="Second slide" />
          <div className="carousel-caption">
            <h3>Second slide label</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </div>
        </div>
        <div className="carousel-item">
          <img src={images[2]} className="d-block w-100" alt="Third slide" />
          <div className="carousel-caption">
            <h3>Third slide label</h3>
            <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
          </div>
        </div>
      </div>
      <a className="carousel-control-prev" href="#carouselAircraft" role="button" data-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a className="carousel-control-next" href="#carouselAircraft" role="button" data-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
  );
}

export default ProjectAircraftwar;
